import React from 'react'
import { notification, Empty, Skeleton } from 'antd'
import { compose } from 'recompose'
import { observer, inject } from 'mobx-react'
import { loadScripts, removeScripts } from './scripts'
import './index.scss'

import Header from './Header'

class Template extends React.Component {

	state = {
	}

	componentDidMount () {
		setTimeout(function () {
		  loadScripts()
		}, 1000)
	}

	componentWillUnmount () {
		// removeScripts()
	}

	render(){
		const { children, isAuthenticated } = this.props
		return isAuthenticated ? <TemplateContent
			toggle={this.toggle}
			{...this.state}
			{...this.props}
		>{children}</TemplateContent> : children
	}
}

const TemplateContent = (props) => {
	const {
		children
	} = props

	return (
		<div id="wrapper">
			<Header />
			<div className="content-page">
				<div className="content">
					<div className="container-fluid">
						{children}
					</div>
				</div>

				<footer>
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-6">
								<img src="/assets/images/poweredbyLogo.png" width={200} alt='vibetech-logo'/>
							</div>
						</div>
					</div>
				</footer>
			</div>
		</div>
	)
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Template)
